/**
 * This file was copied from dashboard into clowncar as part of a cleanup effort
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { LocationDescriptor } from 'history';
import { Redirect, Route, RouteComponentProps } from 'react-router-dom';
import _ from 'lodash';

interface Protection {
  requireThat: boolean;
  elseRedirectTo: LocationDescriptor | null;
}

interface Props {
  component?:
    | React.ComponentType<React.PropsWithChildren<RouteComponentProps<any>>>
    | React.ComponentType<React.PropsWithChildren<any>>;
  render?: (props: RouteComponentProps<any>) => React.ReactNode;
  path?: string;
  protection: Protection | Array<Protection>;
}

/*
 * Route wrapper that redirects a user to a URL if they do not meet a protection
 * (typically whether they are authenticated) and try to access the protected
 * route.
 */
export default class ProtectedRoute extends React.Component<Props> {
  static defaultProps: Partial<Props> = {
    protection: {
      requireThat: false,
      elseRedirectTo: null,
    },
  };

  render() {
    const { component, protection, render, ...rest } = this.props;
    const internalRender: (props: RouteComponentProps) => React.ReactNode = (
      props: RouteComponentProps
    ) => {
      // This reads somewhat complicatedly here in order to make the call sites
      // read very cleanly. The gist is that it goes through the protection(s) in
      // order and the first one where allosIf is false, it will redirect to
      // the given path or else render null if `thenRedirectTo` === null.
      const firstUnmetProtection = _.find(
        Array.isArray(protection) ? protection : [protection],
        (protection) => !protection.requireThat
      );

      if (_.isNil(firstUnmetProtection)) {
        if (component) {
          return React.createElement(component, props);
        } else if (render) {
          return render(props);
        } else {
          return null;
        }
      }

      if (firstUnmetProtection.elseRedirectTo) {
        const toPart =
          typeof firstUnmetProtection.elseRedirectTo === 'string'
            ? { pathname: firstUnmetProtection.elseRedirectTo }
            : firstUnmetProtection.elseRedirectTo;
        const to = {
          ...toPart,
          state: {
            ...(toPart.state as object),
            from: props.location,
          },
        };
        return <Redirect to={to} />;
      }
      return null;
    };

    return <Route {...rest} render={internalRender} />;
  }
}
